import { $t } from '@/utils/languageAuto';
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.join";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.reduce";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.includes";
import "core-js/modules/es.string.match";
import "core-js/modules/web.dom-collections.for-each";
import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import bulkProcessResult from '@/components/bulkProcessResult';
import RequestTaskLimit from '@/utils/requestTaskLimit';
import { enumData, userPrefPageSize, loading } from '@/decorators';
import conf from '@/config';
import { namespace } from 'vuex-class';
import { yesNoStatus } from '@/enum';
import { printPdf, printImage } from '@/utils/printer';
var User = namespace('user');

var TransportOrderListMixins = function (_super) {
  __extends(TransportOrderListMixins, _super);

  function TransportOrderListMixins() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.onevoteEnum = [];
    _this.labelTypeEnum = [];
    _this.orderStatusEnum = [];
    _this.dateTypeEnum = [];
    _this.orderTypeEnum = [];
    _this.loadingStatus = false;
    _this.total = 0;
    _this.orderStatus = _this.$enum.common.StatusEnum.ALL;
    _this.printSettingList = [];
    _this.docValue = '';
    _this.orderListEsPoint = null;
    _this.columns = [];
    _this.selectedList = [];
    _this.searchData = _this.initSearchData();
    _this.searchParam = _this.initSearchData();
    _this.warehouseList = [];
    _this.logisticsList = [];
    _this.countryList = [];
    _this.listData = [];
    _this.statusCountList = [];
    _this.yesNoStatus = yesNoStatus;
    _this.rowSelection = {};
    return _this;
  }

  TransportOrderListMixins.prototype.initSearchData = function () {
    return {
      hawb_codes: [],
      order_type: this.$enum.historyTransportOrder.OrderTypeEnum.SHIPPER,
      country_code: undefined,
      end_time: '',
      start_time: '',
      date_type: this.$enum.historyTransportOrder.DateTypeEnum.PREDICT,
      is_advance: undefined,
      label_type: undefined,
      onevote: undefined,
      page_index: 1,
      page_size: 20,
      page_token: undefined,
      order_status: String(this.$enum.common.StatusEnum.ALL),
      warehouse_code: undefined,
      product_code: undefined
    };
  };

  TransportOrderListMixins.prototype.createShipCodeDataMap = function (selectedList) {
    return this.listData.filter(function (item) {
      return selectedList.includes(item.shipper_hawbcode);
    }).reduce(function (obj, item) {
      obj[item.shipper_hawbcode] = item.order_id;
      return obj;
    }, {});
  };

  TransportOrderListMixins.prototype.bulkProcessResult = function (config) {
    var _this = this;

    var data = config.data.map(function (item) {
      var title = config.content(item);
      return {
        title: title,
        status: _this.$enum.common.BulkProcessResultStatusEnum.LOADING,
        content: ''
      };
    });
    var requestTask = new RequestTaskLimit(conf.requestLimit);
    config.data.forEach(function (item, index) {
      return __awaiter(_this, void 0, void 0, function () {
        var _this = this;

        return __generator(this, function (_a) {
          requestTask.push(function () {
            return __awaiter(_this, void 0, void 0, function () {
              var res, e_1, res;
              return __generator(this, function (_a) {
                switch (_a.label) {
                  case 0:
                    _a.trys.push([0, 2,, 3]);

                    return [4, config.request(item)];

                  case 1:
                    res = _a.sent();

                    if (res.data && res.data.limit_message_list instanceof Array && res.data.limit_message_list.length) {
                      data[index].status = this.$enum.common.BulkProcessResultStatusEnum.FAIL;
                      data[index].content = res.data.limit_message_list.join('\n');
                    } else {
                      data[index].status = this.$enum.common.BulkProcessResultStatusEnum.SUCCESSED;
                      data[index].content = this.t('成功');
                    }

                    return [3, 3];

                  case 2:
                    e_1 = _a.sent();
                    res = e_1;
                    data[index].status = this.$enum.common.BulkProcessResultStatusEnum.FAIL;
                    data[index].content = res.data.message;
                    return [3, 3];

                  case 3:
                    return [2];
                }
              });
            });
          });
          return [2];
        });
      });
    });
    requestTask.start();
    bulkProcessResult({
      title: config.title,
      data: data,
      titleWidth: config.titleWidth,
      width: 800,
      onCancel: function onCancel() {
        typeof config.onCancel === 'function' && config.onCancel();
      }
    });
  };

  TransportOrderListMixins.prototype.queryWarehouseList = function () {
    return __awaiter(this, void 0, void 0, function () {
      var data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.$api.transportOrder.queryWarehouseList({
              is_transport: true
            })];

          case 1:
            data = _a.sent().data;
            this.warehouseList = data;
            return [2];
        }
      });
    });
  };

  TransportOrderListMixins.prototype.queryLogisticsList = function (param) {
    return __awaiter(this, void 0, void 0, function () {
      var data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.$api.transportOrder.queryLogisticsList(Object.assign({
              is_transport: true
            }, param))];

          case 1:
            data = _a.sent().data;
            this.logisticsList = data;
            return [2];
        }
      });
    });
  };

  TransportOrderListMixins.prototype.queryCountryList = function () {
    return __awaiter(this, void 0, Promise, function () {
      var _a, data;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            return [4, this.$api.common.queryCountryList()];

          case 1:
            _a = _b.sent().data, data = _a === void 0 ? [] : _a;
            this.countryList = data;
            return [2];
        }
      });
    });
  };

  TransportOrderListMixins.prototype.queryList = function (param) {
    return __awaiter(this, void 0, Promise, function () {
      var searchData, data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            this.rowSelection.selectedRowKeys = this.selectedList = [];
            searchData = this.$util.deepCopy(param);

            if (String(param.order_status) === String(this.$enum.common.StatusEnum.ALL)) {
              searchData.order_status = undefined;
            }

            this.queryStatusCountList(searchData);
            this.searchParam = this.$util.deepCopy(searchData);
            return [4, this.$api.historyTransportOrder.queryList(searchData)];

          case 1:
            data = _a.sent().data;
            this.listData = data.list;
            this.total = data.total;
            this.searchData.next_token = data.next_token;
            this.searchData.prev_token = data.prev_token;
            this.orderListEsPoint = data.zt_order_list_es_point;
            return [2];
        }
      });
    });
  };

  TransportOrderListMixins.prototype.cancelOrder = function (idList, extendConf) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.$api.historyTransportOrder.cancelOrder({
              order_ids: idList
            }, extendConf)];

          case 1:
            return [2, _a.sent()];
        }
      });
    });
  };

  TransportOrderListMixins.prototype.queryStatusCountList = function (param) {
    return __awaiter(this, void 0, void 0, function () {
      var data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.$api.historyTransportOrder.queryStatusCountList(param)];

          case 1:
            data = _a.sent().data;
            this.statusCountList = data;
            return [2];
        }
      });
    });
  };

  TransportOrderListMixins.prototype.queryPrintSetting = function () {
    return __awaiter(this, void 0, void 0, function () {
      var data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.$api.transportOrder.queryPrintSettingList()];

          case 1:
            data = _a.sent().data;
            this.printSettingList = data;
            return [2];
        }
      });
    });
  };

  TransportOrderListMixins.prototype.exportList = function (param) {
    return __awaiter(this, void 0, void 0, function () {
      var data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.$api.historyTransportOrder.exportOrder(param)];

          case 1:
            data = _a.sent().data;
            this.$util.exportExcel(data);
            return [2];
        }
      });
    });
  };

  TransportOrderListMixins.prototype.getList = function () {
    this.queryList(this.searchData);
  };

  TransportOrderListMixins.prototype.initColumns = function () {
    this.columns = [{
      title: this.t('运单号'),
      name: 'shipper_hawbcode',
      disabled: true,
      scopedSlots: {
        customRender: 'shipper_hawbcode'
      }
    }, {
      title: this.t('客户单号'),
      dataIndex: 'refer_hawbcode',
      name: 'refer_hawbcode',
      filterEmpty: true,
      width: 100,
      isCopy: true
    }, {
      title: this.t('跟踪号'),
      name: 'server_hawbcode',
      dataIndex: 'server_hawbcode',
      filterEmpty: true,
      isCopy: true
    }, {
      title: this.t('小标签号'),
      dataIndex: 'small_labelcode',
      name: 'small_labelcode',
      filterEmpty: true,
      isCopy: true
    }, {
      title: this.t('预报仓库'),
      name: 'warehouse_name',
      scopedSlots: {
        customRender: 'warehouse_code'
      },
      width: 150,
      filterEmpty: true
    }, {
      title: this.t('物流产品'),
      name: 'product_code',
      dataIndex: 'product_code',
      width: 150
    }, {
      title: this.t('标签类型'),
      name: 'label_type_str',
      dataIndex: 'label_type_str',
      isCopy: true,
      width: 150
    }, {
      title: this.t('订单类型'),
      dataIndex: 'onevote_text',
      name: 'onevote_text',
      filterEmpty: true
    }, {
      title: this.t('收件人'),
      scopedSlots: {
        customRender: 'consignee_name'
      },
      name: 'consignee_name',
      filterEmpty: true,
      width: 150
    }, {
      title: this.t('国家/地区'),
      name: 'country_name',
      dataIndex: 'country_name',
      filterEmpty: true
    }, {
      title: this.t('订单标识'),
      checked: false,
      name: 'order_create_code_text',
      dataIndex: 'order_create_code_text'
    }, {
      title: this.t('订单状态'),
      name: 'order_status_str',
      scopedSlots: {
        customRender: 'order_status_str'
      },
      filterEmpty: true
    }, {
      title: this.t('取消单状态'),
      name: 'cancel_status_text',
      dataIndex: 'cancel_status_text',
      filterEmpty: true
    }, {
      title: this.t('备注'),
      name: 'order_info',
      dataIndex: 'order_info',
      filterEmpty: true
    }, {
      title: this.t('预上网'),
      name: 'is_advance_str',
      dataIndex: 'is_advance_str'
    }, {
      title: this.t('时间'),
      name: 'time',
      scopedSlots: {
        customRender: 'time'
      }
    }, {
      title: this.t('操作'),
      key: 'operation',
      name: 'operation',
      showColumnSetting: true,
      fixed: 'right',
      scopedSlots: {
        customRender: 'operation'
      },
      width: 200
    }];
  };

  TransportOrderListMixins.prototype.cancelOrderOperation = function (data, dataMap) {
    var _this = this;

    this.bulkProcessResult({
      title: this.t('取消订单'),
      titleWidth: 300,
      data: data,
      request: function request(item) {
        return __awaiter(_this, void 0, Promise, function () {
          return __generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                return [4, this.cancelOrder([dataMap[item]], {
                  showError: false
                })];

              case 1:
                return [2, _a.sent()];
            }
          });
        });
      },
      content: function content(item) {
        return _this.tc('运单号') + _this.tc('：') + item;
      },
      onCancel: function onCancel() {
        _this.getList();
      }
    });
  };

  TransportOrderListMixins.prototype.downloadShippingCertification = function (param) {
    return __awaiter(this, void 0, void 0, function () {
      var res;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.$api.historyTransportOrder.downloadShippingCertification(param)];

          case 1:
            res = _a.sent();
            this.$util.blobToFile(this.t('发货证明.zip'), res);
            return [2];
        }
      });
    });
  };

  TransportOrderListMixins.prototype.printLabel = function (param) {
    return __awaiter(this, void 0, void 0, function () {
      var data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.$api.historyTransportOrder.printLabel(param)];

          case 1:
            data = _a.sent().data;
            return [2, data];
        }
      });
    });
  };

  TransportOrderListMixins.prototype.execPrintLabel = function (data, configItem) {
    return __awaiter(this, void 0, void 0, function () {
      var printData, res, width, height;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.printLabel({
              shipper_hawbcode: data.shipper_hawbcode
            })];

          case 1:
            printData = _a.sent();
            res = printData.file_name.match(/\.([a-zA-Z]+)$/);
            width = data.label_type === this.$enum.transportOrder.LabelTypeEnum.LARGE ? Number(configItem.label_refer_width) : 70;
            height = data.label_type === this.$enum.transportOrder.LabelTypeEnum.LARGE ? Number(configItem.label_refer_length) : 30;

            if (res && res[1]) {
              if (res[1] === 'pdf') {
                printPdf({
                  url: printData.remote_url,
                  width: width,
                  height: height,
                  printIndex: Number(configItem.print_index)
                });
                return [2];
              }
            }

            printImage({
              title: this.tc('标签打印'),
              url: printData.remote_url,
              width: width,
              height: height,
              printIndex: Number(configItem.print_index)
            });
            return [2];
        }
      });
    });
  };

  __decorate([User.State('customerInfo')], TransportOrderListMixins.prototype, "customerInfo", void 0);

  __decorate([enumData('OldOrderPredict/OnevoteEnum')], TransportOrderListMixins.prototype, "onevoteEnum", void 0);

  __decorate([enumData('OldOrderPredict/LabelTypeEnum')], TransportOrderListMixins.prototype, "labelTypeEnum", void 0);

  __decorate([enumData('OldOrderPredict/OrderStatusEnum')], TransportOrderListMixins.prototype, "orderStatusEnum", void 0);

  __decorate([enumData('OldOrderPredict/DateTypeEnum')], TransportOrderListMixins.prototype, "dateTypeEnum", void 0);

  __decorate([enumData('OldOrderPredict/OrderTypeEnum')], TransportOrderListMixins.prototype, "orderTypeEnum", void 0);

  __decorate([userPrefPageSize('historyTransportOrderList')], TransportOrderListMixins.prototype, "initSearchData", null);

  __decorate([loading('loadingStatus')], TransportOrderListMixins.prototype, "queryList", null);

  TransportOrderListMixins = __decorate([Component], TransportOrderListMixins);
  return TransportOrderListMixins;
}(Vue);

export default TransportOrderListMixins;